import React, { useContext, useEffect, useState } from "react";
import { ShopContext } from "../Context/ShopContext";
import { useParams } from "react-router-dom";
import Breadcrum from "../Components/Breadcrum/Breadcrum";
import ProductDisplay from "../Components/ProductDisplay/ProductDisplay";
import RateAndReviewBox from "../Components/RateAndReviewBox/RateAndReviewBox";
import RelatedProducts from "../Components/RelatedProducts/RelatedProducts";
import PageLoader from "../Components/Assets/PageLoader/PageLoader";
import { callMultipleApis } from "../services/ApiServices";

const reviewListURL = process.env.REACT_APP_REVIEWLIST_URL;

const Product = () => {
  const { all_products, loading } = useContext(ShopContext);
  const { productId } = useParams();

  const [averageRating, setAverageRating] = useState(0);
  const [totalReviews, setTotalReviews] = useState(0);
  const [reviewsList, setReviewsList] = useState([]);


  useEffect(() => {

    fetchProductReview();

  }, []);

  const fetchProductReview = async () => {
    try {
      const data = { productid: productId };
      const [response] = await callMultipleApis([
        {
          url: reviewListURL,
          method: "POST",
          data: data,
          params: {},
          headers: {},
        }
      ]);
      if (response.status === true) {
 
        setReviewsList(response.result.reviews);
        setAverageRating(response.result.avgRating);
        setTotalReviews(response.result.totalReviews);
      }

    } catch (error) {

    }
  }


  // While API is loading
  if (loading) {
    return <PageLoader text="Loading product" />;
  }

  const product = all_products.find(
    (e) => e.item_id === Number(productId)
  );

  // If product not found (invalid URL / API issue)
  if (!product) {
    return <div>Product not found</div>;
  }

  return (
    <div>
      <Breadcrum product={product} />
      <ProductDisplay product={product} averageRating={averageRating} totalReviews={totalReviews} />
      <RateAndReviewBox product={product} reviews={reviewsList} setReviews={setReviewsList} fetchProductReview={fetchProductReview} />
      <RelatedProducts categoryId={product.item_category_id} />
    </div>
  );
};

export default Product;
